<template>
  <el-dialog
      class="Classification"
      title="分类选择"
      :visible.sync="categoryShow"
      append-to-body
      width="1300px"
      top="10vh">
    <div style="display: flex; width: 100%">
      <el-input
          v-model="categorySearchText"
          placeholder="请输入搜索内容"
          style="margin-right: 20px"></el-input>
       <el-button type="primary" @click="fetchCategoryByName" v-if="(sellerId && isTuijian) || (!isTuijian)">搜 索</el-button>
      <el-button type="primary" @click="resetCategorySearch" v-if="!isTuijian">重 置</el-button>
    </div>
    <template v-if="!categorySearch && !isTuijian">
      <div
          style="
            display: flex;
            align-items: center;
            height: 50px;
            background: rgba(255, 244, 240, 1);
            font-size: 14px;
            border: 1px solid indianred;
            color: indianred;
            margin-top: 10px;
            padding-left: 10px;
          ">
        <span>当前所选类目是：{{ categorySelectFullName }}</span>
      </div>
      <el-cascader-panel
          class="custom-cascader"
          :key="keyNum"
          v-model="cascaderValue"
          ref="CascaderPanelRef"
          style="height: 500px"
          :options="categoryList"
          :props="categoryProps"
          @change="onCascaderPanelChange"
          @expand-change="onCascaderPanelExpandChange"></el-cascader-panel>
    </template>
    <div class="search_box2" v-else>
        <div style="width: 100%">
          <div class="leimu_box2">
            <div
              :class="{
                select_leimu: (item.id === formData.categoryId || item.categoryId === formData.categoryId)
              }"
              class="leimu_item"
              v-for="(item, index) in categorySearchList"
              :key="index"
              @click="confirmCategorySearch(item)">
              <div class="leimu_item_desc" v-html="item.fullLabel"></div>
            </div>
          </div>
        </div>
      </div>
    <span slot="footer" style="margin-top: 60px">
        <el-button @click="categoryShow = false">取 消</el-button>
        <el-button
            type="primary"
            :disabled="!categoryIsConfirm"
            @click="confirmCategory">
          选 择
        </el-button>
      </span>
  </el-dialog>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from '@/api/api/api'
export default {
  name: 'leimu',
  data() {
    return {
      //店铺id
      sellerId:'',
      cascaderValue:null,
      // 类目
      categoryShow: false,
      keyNum:0,
      categoryList: [],
      categoryProps: {
        expandTrigger: 'click',
        lazy: true,
        lazyLoad: async (node, resolve) => {
          const id = node.root ? 0 : node.value.categoryId
          const list = await this.fetchNextCategory(id)
          resolve(list)
        }
      },
      categorySelectFullName: '',
      //是否为推荐搜索
      isTuijian:false,
      categorySearch: false,
      //属性名
      categorySearchText: '',
      categorySearchList: [],
      categoryIsConfirm: false,
      formData: {},
    }
  },
  created() {},
  methods: {
    openDialog(status){
        this.isTuijian = status == 'tuijian'
      if (status != 'tuijian'){
        this.categorySearchText = ''
        this.categorySearch = false
      } else {
        this.categorySearch = true
        this.fetchCategoryByName()
      }
        this.categoryShow = true
        this.formData.categoryList = []
        this.cascaderValue = null
        this.keyNum += 1
        this.categorySelectFullName = ''
    },
    // 获取类目下级
    async fetchNextCategory(id) {
      try {
        const url =
            Baseurl + `/allegroCategory/getCategoryByParentId/${id}`
        const res = await ajaxGet(url)
        const { code, data } = res.data
        if (code === 200) {
          const list = data.map((item) => {
            const label = `${item.enName} - ${item.cnName}`
            return {
              label,
              value: { label, ...item },
              leaf: item.leaf
            }
          })
          return list
        }
        return false
      } catch (error) {
      }
    },
    // 选择类目确认
    confirmCategory() {
      const res = this.$refs.CascaderPanelRef.getCheckedNodes()
      if (res.length) {
        this.formData.categoryName = res[0].value.label
        this.formData.categoryId = res[0].value.categoryId

        this.fetchCategoryByAttr()
      }
    },
    // 获取类目属性
    async fetchCategoryByAttr() {
      let loading
      try {
        loading = this.$loading({ text: '正在获取分类属性' })
        const url = Baseurl + '/allegroCategory/getCategoryParameterAndDictionary'
        const payload = { categoryId: this.formData.categoryId }
        // const payload = { categoryId: 100434 }
        const res = await ajaxPost(url, payload)
        loading.close()
        const { code, data } = res.data
        if (code === 200) {
          this.$emit('categoryAttr', data,this.formData.categoryName,this.formData.categoryId)
          this.categoryShow = false
        }
      } catch (error) {
        loading.close()
      }
    },


    // 打开选择类目
    async openCategoryDialog() {
      this.categoryShow = true
    },
    onCascaderPanelChange(e) {
      this.categorySelectFullName = ''
      for (let i = 0, len = e.length; i < len; i++) {
        const item = e[i]
        if (i === len - 1) {
          this.categorySelectFullName += `${item.label}`
        } else {
          this.categorySelectFullName += `${item.label} > `
        }
      }
      this.categoryIsConfirm = true
    },
    onCascaderPanelExpandChange(e) {
      this.categorySelectFullName = ''
      for (let i = 0, len = e.length; i < len; i++) {
        const item = e[i]
        this.categorySelectFullName += `${item.label} > `
      }
      this.categoryIsConfirm = false
    },

    // 搜索类目
    async fetchCategoryByName() {
      let loading
      //推荐搜索接口
      if (this.isTuijian){
        try {
          if (!this.categorySearchText) return
          loading = this.$loading({ text: '正在获取推荐类目...' })
          const url =
              Baseurl + '/allegroCategory/matchingCategories'
          const payload = {
            sellerId:this.sellerId,
            name: this.categorySearchText }
          const res = await ajaxPost(url, payload)
          const { code, data } = res.data
          if (code === 200) {
            loading.close()
            this.categorySearchList = data.map((item) => {
              const fullLabel = `${item.enName} - ${item.cnName}`
              return { fullLabel, ...item }
            })
          }
        } catch (error) {
          loading.close()
        }
      } else {
        try {
          if (!this.categorySearchText) return
          this.categorySearch = true
          loading = this.$loading({ text: '正在获取检索类目...' })
          const url =
              Baseurl + '/allegroCategory/selectAllegroCategoryByName'
          const payload = {
            name: this.categorySearchText }
          const res = await ajaxPost(url, payload)
          const { code, data } = res.data
          if (code === 200) {
            loading.close()
            this.categorySearchList = data.map((item) => {
              const label = `${item.enName} - ${item.cnName}`
              const fullLabel = `${item.enFullName} - ${item.cnFullName}`
              return { label,fullLabel, ...item }
            })
          }
        } catch (error) {
          loading.close()
        }

      }
    },
    confirmCategorySearch(item){
      this.formData.categoryName = item.fullLabel
      if (this.isTuijian){
        this.formData.categoryId = item.id
      } else {
        this.formData.categoryId = item.categoryId
      }
      this.fetchCategoryByAttr()
    },
    // 重置类目搜索
    resetCategorySearch() {
      this.isTuijian = false
      this.categorySearch = false
      this.categorySearchText = ''
    },

    onCascaderPanelChange(e) {
      this.categorySelectFullName = ''
      for (let i = 0, len = e.length; i < len; i++) {
        const item = e[i]
        if (i === len - 1) {
          this.categorySelectFullName += `${item.label}`
        } else {
          this.categorySelectFullName += `${item.label} > `
        }
      }
      this.categoryIsConfirm = true
    },
    onCascaderPanelExpandChange(e) {
      this.categorySelectFullName = ''
      for (let i = 0, len = e.length; i < len; i++) {
        const item = e[i]
        this.categorySelectFullName += `${item.label} > `
      }
      this.categoryIsConfirm = false
    },
  }
}
</script>
<style lang="scss" scoped>
@import '../ozon.less';
.information_input {
  margin: 0 auto 10px;
  display: flex;
  justify-content: center;
  .input_el {
    flex: 1;
  }
  .information_Title {
    width: 30% !important;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.Classification{
  // 级联面板
	.el-cascader-panel.custom-cascader {
		overflow: auto;
		/deep/ .el-cascader-menu__wrap {
			height: 500px;
		}
	}
}
.search_box2{
  padding: 15px 0px 15px 2px;
  width: calc(100%);
  background: rgb(238,238,238);
  margin-top: 10px;
}
.leimu_box2{
  height: 400px;
  padding: 10px;
  overflow-y: auto;
  background: white;
  width: calc(100% - 20px);
  .leimu_item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 7px 0;
    font-size: 14px;
    .leimu_item_desc{
      width:calc(100% - 20px);
      white-space: nowrap;      /* 确保文本在一行内显示 */
      overflow: hidden;         /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
    }
    .item_leimu_you{
      color: rgb(82,190,166);
      margin-top: 3px;
    }
  }
  .select_leimu {
    border: 1px solid rgb(82,190,166);
    box-sizing: content-box;
  }
  .leimu_item:hover{
    border: 1px solid rgb(82,190,166);
    color: rgb(82,190,166);
    box-sizing: content-box;
  }
}
</style>
